import ValueX from '../types/ValueX';

export default class StartX extends ValueX {
    static __className = 'StartX';

    constructor(constructJson) {
        super(constructJson, 'start', 'StartX');
    }
}
